import { Alert, Button } from 'antd';

import useLocale from '../../../hooks/useLocale';
import { getErrorMessage } from './utils';

interface IProps {
  error: unknown;
  onRetry: () => void;
}

const LoadErrorAlert = ({ error, onRetry }: IProps): JSX.Element => {
  const { t } = useLocale();

  return (
    <Alert
      className="integration-monitoring__alert"
      type="error"
      showIcon
      message={getErrorMessage(error, t.INTEGRATION_LOAD_FAILED)}
      action={
        <Button size="small" type="link" onClick={onRetry}>
          {t.RETRY}
        </Button>
      }
    />
  );
};

export default LoadErrorAlert;
